import { render, staticRenderFns } from "./addUserGroup.vue?vue&type=template&id=bf05f5f8&scoped=true&"
import script from "./addUserGroup.vue?vue&type=script&lang=js&"
export * from "./addUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./addUserGroup.vue?vue&type=style&index=0&id=bf05f5f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05f5f8",
  null
  
)

export default component.exports